import { render, staticRenderFns } from "./customCheckBlock.vue?vue&type=template&id=0bf30929&scoped=true&"
import script from "./customCheckBlock.vue?vue&type=script&lang=js&"
export * from "./customCheckBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf30929",
  null
  
)

export default component.exports